const authMethods = {
  apiKey: 'ApiKey',
  basic: 'Basic',
  jwt: 'JWT',
};

export default authMethods;
